import {
  Box,
  Center,
  Flex,
  ListItem,
  Text,
  UnorderedList,
} from "@chakra-ui/react";
import BaseImage from "@components/BaseImage";
import UTMLink from "@components/UTMLink";
import { LP_INFO } from "@constants/analytics";
import { useState } from "react";
import { getUrlForLocalImage, trackEvent } from "utils";
import { InfoDataType } from "../landingConstants";

interface InfoCardProps {
  data: InfoDataType;
}

const InfoCard = ({ data }: InfoCardProps) => {
  const [isHovered, setIsHovered] = useState(false);

  return (
    <Flex
      position="relative"
      minH={{ base: "180px", md: "360px" }}
      bg="#1B443D"
      flex={1}
      borderRadius="36px"
      w={{ base: "100%" }}
      overflow="hidden"
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      transition="flex 0.3s ease"
      _hover={{ flex: 1.8 }}
      boxShadow={isHovered ? "none" : "inset 0 0 0 1000px rgba(27,68,61,.5)"}
    >
      <UTMLink
        position="relative"
        href={data.link}
        _hover={{
          borderBottom: "none",
        }}
        onClick={() => {
          trackEvent(LP_INFO, {
            name: data.title,
          });
        }}
        w="100%"
      >
        <Box
          position="absolute"
          top="0"
          left="0"
          right="0"
          bottom="0"
          backgroundImage={getUrlForLocalImage(data.bgImg)}
          backgroundSize="cover"
          backgroundRepeat="no-repeat"
          backgroundPosition="center"
          opacity={isHovered ? 1 : 0.5}
          zIndex="0"
          borderRadius="36px"
          transition="flex 0.3s ease"
          w="100%"
        />
        <Flex
          flexDir="column"
          gap={{ base: "4px", md: "12px" }}
          p={{ base: "16px 24px", md: "24px", lg: "48px" }}
        >
          <Flex
            position="relative"
            zIndex="1"
            justifyContent="space-between"
            alignItems="center"
          >
            <Text
              fontSize={{ base: "24px", md: "32px" }}
              lineHeight={{ base: "28px", md: "38px" }}
              fontWeight={{ base: "500", md: "600" }}
              letterSpacing="-0.32px"
              color="#FFF"
            >
              {data.title}
            </Text>

            <Center
              w={{ base: "40px", md: "60px" }}
              h={{ base: "40px", md: "60px" }}
              bg="#FFF"
              _hover={{
                bg: "#D8F0F0",
              }}
              borderRadius="50%"
              display={{ base: "flex", md: isHovered ? "flex" : "none" }}
              cursor={"pointer"}
            >
              <BaseImage
                src="/assets/arrow.svg"
                height={25}
                width={25}
                alt="arrow"
              />
            </Center>
          </Flex>
          <UnorderedList zIndex={1}>
            {data?.details?.map((data) => (
              <ListItem
                key={data}
                color="#D8F0F0"
                fontSize={{ base: "12px", md: "14px" }}
                fontWeight={{ base: "400px", md: "500" }}
                lineHeight={{ base: "14px", md: "20px" }}
              >
                {data}
              </ListItem>
            ))}
          </UnorderedList>
        </Flex>
      </UTMLink>
    </Flex>
  );
};

export default InfoCard;
